import type { FC } from 'react';

import { Tag } from 'antd';

import IntlMessages from '@src/util/IntlMessages';

export type MarkAttendanceJourneyLabelProps = {
  /** Assigned journey name; empty / null shows the no-journey gray tag. */
  journeyName?: string | null;
};

/** Journey cell for the Mark Attendance user list. */
export const MarkAttendanceJourneyLabel: FC<MarkAttendanceJourneyLabelProps> = ({
  journeyName,
}) => {
  const name = journeyName?.trim();
  if (name) {
    return <span>{name}</span>;
  }

  return (
    <Tag className="gx-mb-0 gx-mr-0" color="default">
      <IntlMessages id="workJourney.management.plan.noJourney" />
    </Tag>
  );
};
